export default "__VITE_ASSET__d81a4f8e__"